import { render } from "./CashierKeyboard.vue?vue&type=template&id=2dc468ac"
import script from "./CashierKeyboard.vue?vue&type=script&lang=js"
export * from "./CashierKeyboard.vue?vue&type=script&lang=js"

import "./CashierKeyboard.vue?vue&type=style&index=0&id=2dc468ac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__